/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Smarts Conversation UI
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import * as tf from '@tensorflow/tfjs'
export default class MinMaxScaler {
  /**
   *
   * @constructor
   */
  constructor(t) {
    if (t) {
      this._init(t)
    } else {
      this.min = null;
      this.max = null;
    }
  }
  /**
   * Scale data from 0-1 based on fitting
   *
   * @param {list, list} t: tensor to transform
   */
  _init(t) {
    const axis = 0;
    this.min = t.min(axis);
    this.max = t.max(axis);
    this._checkMaxMinValue()
  }
  getMin() {
    return this.min.dataSync()
  }

  getMax() {
    return this.max.dataSync()
  }

  /**
   * If min == max for a column, a NaN value will return
   * In this case, we add 1 to max
   * 
   * @param {list, list} t: tensor to transform
   */
  _checkMaxMinValue()
  {
    // max should be greater than min
    const condition = this.max.greater(this.min);
    const ones = tf.onesLike(this.max);
    const maxPlusOne = this.max.add(ones);
    const newMaxValues = this.max.where(condition, maxPlusOne);
    this.max = newMaxValues;
  }

  /**
   * Scale data from 0-1 based on fitting
   *
   * @param {list, list} t: tensor to transform
   */
  setMinMaxValues(minArr, maxArr) {
    this.min = tf.tensor(minArr);
    this.max = tf.tensor(maxArr);
  }

  /**
   * Scale data from 0-1 based on fitting
   *
   * @param {tf.tensor} t: tensor to transform
   * @returns {tf.tensor} normalized tensor
   */
  transform(t) {
    // t' = (t - min)/ (max - min)
    return t.sub(this.min).div(this.max.sub(this.min))
  }

  /**
   * Descale data to orginal scaling
   *
   * @param {tf.tensor} t: tensor to transform
   * @returns {tf.tensor} denormalized tensor
   */
  inverseTransform(t) {
    // t = (t' * (tmax - tmin)) + tmin
    return t.mul(this.max.sub(this.min)).add(this.min)
  }
}
